<template>
  <v-dialog
    v-model="displayEventDialog"
    hide-overlay
    :fullscreen="isMobile"
    transition="fade-transition"
    content-class="event-dialog"
    :max-width="isMobile ? '' : '350px'"
  >
    <v-dialog
      content-class="event-remove-dialog"
      v-model="displayRemoveEventDialog"
      persistent
      no-click-animation
      max-width="220px"
    >
      <v-card>
        <v-card-actions>
          <v-btn
            text
            @click="displayRemoveEventDialog = false"
          >{{ $store.state.user.langEng ? 'Cancel' : 'Avbryt' }}</v-btn>
          <v-btn
            color="red lighten-2"
            @click="removeEvent"
          >{{ $store.state.user.langEng ? 'Remove' : 'Ta bort' }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card
      class="event-card text-start"
      color="grey lighten-4"
      :min-width="isMobile ? '' : '350px'"
      flat
    >
      <v-toolbar
        height="50px"
        :flat="isMobile"
        :color="isMobile ? 'transparent' : event.color"
        :dark="!isMobile"
      >
        <v-toolbar-title>
          <v-icon v-if="isMobile" class="mr-2" :color="event.color">fiber_manual_record</v-icon>
          {{event.title}}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="allowedToEdit" @click="emitEditEvent()" icon>
          <v-icon>edit</v-icon>
        </v-btn>
        <v-btn v-if="allowedToEdit" @click="displayRemoveEventDialog = true" icon>
          <v-icon>delete</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="event-card-content col p-2" :class="{'px-3': isMobile}">
        <div class="pt-2">
          <h5>{{$store.state.user.langEng ? 'Time' : 'Tid'}}</h5>
          <p>{{date}}</p>
          <div v-if="event.location">
            <h5 class="location-text">{{$store.state.user.langEng ? 'Location' : 'Plats'}}</h5>
            <p>{{event.location}}</p>
          </div>
        </div>
        <div v-if="event.users && event.users.length" class="mb-2">
          <div v-if="shouldDisplayTeacher">
            <h5>{{$store.state.user.langEng ? 'Teacher' : 'Lärare'}}</h5>
          </div>
          <div v-else>
            <h5>{{$store.state.user.langEng ? 'Participants' : 'Deltagare'}}</h5>
          </div>
          <p
            class="mb-0"
          >{{event.users.map(u => u.name || u.firstname + ' ' + u.lastname).join(', ')}}</p>
        </div>
        <div v-if="event.agenda">
          <h5>Agenda</h5>
          <p id="markdown-text" class="text-start" v-html="agenda"></p>
        </div>
        <div v-if="event.schools && event.schools.length" class="mb-2">
          <h5>{{$store.state.user.langEng ? 'School' : 'Skola'}}</h5>
          <p class="mb-0">{{event.schools.map(c => c.name).join(', ')}}</p>
        </div>
        <div class="mb-2">
          <div v-if="event.courses && event.courses.length" class="mb-2">
            <h5>{{$store.state.user.langEng ? 'Course' : 'Kurs'}}</h5>
            <p class="mb-0">{{event.courses.map(c => `${c.name} (${c.klassSlug})`).join(', ')}}</p>
          </div>
          <div v-if="event.klasses && event.klasses.length" class="mb-2">
            <h5>{{$store.state.user.langEng ? 'Class' : 'Klass'}}</h5>
            <p class="mb-0">{{event.klasses.map(c => c.name).join(', ')}}</p>
          </div>
          <div v-if="event.creators && event.creators.length && !shouldDisplayTeacher" class="mb-2">
            <h5>{{$store.state.user.langEng ? 'Creator' : 'Skapare'}}</h5>
            <p class="mb-0">{{event.creators[0].firstname + ' ' + event.creators[0].lastname}}</p>
          </div>
        </div>
      </div>
      <v-btn
        text
        :fixed="isMobile"
        :class="{'sticky-close-button': isMobile}"
        :color="event.color"
        @click="closeEventDialog"
      >{{$store.state.user.langEng ? 'Close' : 'Stäng'}}</v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
import { Vue, Component, Watch, Emit } from "vue-property-decorator";
import marked from "marked";
import { deleteFetch } from "@/utils";
import $ from "jquery";

@Component
export default class EventDialog extends Vue {
  displayEventDialog = false;
  displayRemoveEventDialog = false;

  @Watch("$store.state.calendar.showActiveEvent")
  watchActiveEvent(val) {
    if (val) {
      this.displayEventDialog = true;
      if (this.isMobile) $("#nav").addClass("sticky");
    }
  }
  closeEventDialog() {
    this.displayEventDialog = false;
    this.$store.commit('calendar/toggleActiveEvent', false)
    if (this.isMobile) $("#nav").removeClass("sticky");
  }

  @Watch('displayEventDialog')
  watchDisplayEventDialog(val) {
    if (!val) {
      this.closeEventDialog()
    }
  }

  @Emit("editEvent")
  emitEditEvent() {
    this.displayEventDialog = false;
    return this.event;
  }

  removeEvent() {
    this.displayEventDialog = false;
    deleteFetch("/rest/CalendarEvent/" + this.event._id);
    this.$store.commit("calendar/removeEvent", this.event);
  }

  get agenda() {
    return marked(this.event.agenda || "");
  }

  get date() {
    if (!this.event.start) {
      return '';
    }
    let options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric"
    };

    let start =
      this.event.start &&
      new Date(this.event.start)
        .toLocaleTimeString("sv-SE", options)
        .slice(0, -3);
    let end = new Date(this.event.end)
      .toLocaleTimeString("sv-SE", options)
      .slice(0, -3);
    const sameDate = start.slice(0, -6) == end.slice(0, -6);
    if (sameDate) end = end.slice(-5);
    return start + " - " + end;
  }

  get shouldDisplayTeacher() {
    return this.event.users.length == 1 && this.event.users.find(u => !u.roles.includes('student'));
  }

  get allowedToEdit() {
    return this.isAdmin || !!(this.event.creators || []).find(user => user.id == this.user.id)
  }

  get isAdmin() {
    return this.$store.getters.isAdmin;
  }

  get user() {
    return this.$store.state.user.loggedInUser;
  }

  get isMobile() {
    return this.$store.state.isMobile;
  }

  get event() {
    return this.$store.state.calendar.editEvent;
  }
}
</script>

<style lang="scss">
.event-card {
  display: flex;
  flex-direction: column;
  .event-card-content {
    flex: 1;
  }
  #markdown-text {
    padding-top: 0;
    max-height: 40vh;
    overflow-x: auto;
    & > :first-child {
      margin-top: 0 !important;
    }
  }
}

.mobile {
  .sticky-close-button {
    position: fixed;
    bottom: 0;
    width: 100%;
    margin: 5px 0;
  }
}
</style>
